import { useState, createContext, useContext } from "react";

const PermissionsContext = createContext(null);

export const PermissionsProvider = ({ children }) => {
  const [permissions, setPermissions] = useState(
    () =>
      localStorage.getItem("userPermissions") != "undefined" &&
      JSON.parse(localStorage.getItem("userPermissions"))
  );
  document.addEventListener("localdatachanged", () => {
    setPermissions(JSON.parse(localStorage.getItem("userPermissions")));
  });
  const checkPermission = (key) => {
    return permissions.some((permission) => permission.claimKey === key);
  };

  return (
    <PermissionsContext.Provider value={{ checkPermission, setPermissions }}>
      {children}
    </PermissionsContext.Provider>
  );
};
export const usePermission = () => {
  return useContext(PermissionsContext);
};
